import { useT, useRaw } from '@/lib/i18n';

const COLORS = ['#0EA5E9', '#8B5CF6', '#F97316'];

export const HowItWorks = () => {
  const t = useT();
  const raw = useRaw();
  const steps = raw('home.how.steps') || [];
  return (
    <section
      data-testid="section-how"
      className="relative py-20 md:py-28"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-10 flex items-center justify-center"
      >
        <div
          className="h-[420px] w-[80%] rounded-full opacity-40 blur-3xl"
          style={{
            background:
              'radial-gradient(closest-side, rgba(139,92,246,0.14), rgba(14,165,233,0.08), transparent 70%)',
          }}
        />
      </div>

      <div className="om-container">
        <div className="max-w-2xl">
          <span className="om-eyebrow">{t('home.how.eyebrow')}</span>
          <h2
            className="om-h1 mt-5 text-[36px] sm:text-[46px] lg:text-[56px] text-[var(--om-ink)]"
            data-testid="how-title"
          >
            {t('home.how.title_l1')}<br />{t('home.how.title_l2')}
          </h2>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-[var(--om-muted)]">
            {t('home.how.subtitle')}
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          {steps.map((s, i) => {
            const color = COLORS[i % COLORS.length];
            const n = String(i + 1).padStart(2, '0');
            return (
              <div
                key={i}
                data-testid={`how-step-${i + 1}`}
                className="relative flex flex-col rounded-3xl border border-[var(--om-border)] bg-white/70 p-8 shadow-[0_1px_0_rgba(255,255,255,0.9)_inset,0_10px_30px_-20px_rgba(10,14,26,0.10)] backdrop-blur"
              >
                <div className="flex items-center gap-3">
                  <span
                    className="grid h-11 w-11 place-items-center rounded-2xl text-sm font-bold text-white"
                    style={{
                      background: `linear-gradient(135deg, ${color}, ${color}dd)`,
                      boxShadow: `0 10px 24px -12px ${color}80`,
                    }}
                  >
                    {n}
                  </span>
                  <div className="h-px flex-1 bg-gradient-to-r from-[var(--om-border)] to-transparent" />
                </div>

                <h3 className="mt-6 text-[22px] font-bold tracking-tight text-[var(--om-ink)]">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[var(--om-muted)]">
                  {s.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
